import { InvoiceStatus } from '@application/common/enums/invoice-status';
import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function InvoiceTabsHelpers() {
    const { unchangedInvoice } = useAppSelector((state) => state.invoice);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formdata, setFormData] = useState({
        id: 0,
        invoiceNumber: '',
        invoiceDate: new Date(),
        workOrderId: 0,
        debtorId: 0,
        bookYear: 0,
        bookMonth: 0,
        note: '',
        statusId: InvoiceStatus.Concept,
        debtorEmail: null,
        debtorInvoiceEmail: ''
    });
    const [errors, setErrors] = useState({
        invoiceNumber: '',
        workOrderId: '',
        debtorId: '',
        invoiceDate: ''
    });
    useEffect(() => {
        if (!errors.workOrderId && !errors.debtorId && !errors.invoiceDate) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        if (fieldName == 'bookMonth' || fieldName == 'bookYear') {
            const updatedValue = value === '' ? 0 : parseInt(value);
            setFormData((prevData) => ({
                ...prevData,
                [fieldName]: updatedValue
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldName]: ''
            }));
        }
        else {
            setFormData((prevData) => ({
                ...prevData,
                [fieldName]: value
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldName]: ''
            }));
        }
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    useEffect(() => {
        checkBoldFieldsInvoice();
        checkUnchangedFieldsInvoice();
    }, [formdata, unchangedInvoice]);
    const validateForm = () => {
        const newErrors = {
            invoiceNumber: '',
            workOrderId: '',
            debtorId: '',
            invoiceDate: ''
        };
        // if (formdata.invoiceNumber === null || formdata.invoiceNumber.trim() === '') {
        //     newErrors.invoiceNumber = 'Dit veld is verplicht';
        // }
        if (formdata.workOrderId <= 0) {
            newErrors.workOrderId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.debtorId <= 0) {
            newErrors.debtorId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (!formdata.invoiceDate) {
            newErrors.invoiceDate = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isNotesTabUnsaved, setNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkUnchangedFieldsInvoice = () => {
        if (unchangedInvoice && formdata && id) {
            let isInfoTabUnsaved = false;
            let isNotesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedInvoice.workOrderId != formdata.workOrderId ||
                unchangedInvoice.debtorId != formdata.debtorId ||
                unchangedInvoice.invoiceDate != formdata.invoiceDate ||
                unchangedInvoice.bookYear != formdata.bookYear ||
                unchangedInvoice.bookMonth != formdata.bookMonth) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the Notes
            if (formdata.note !== unchangedInvoice.note) {
                isNotesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setNotesTabUnsaved(isNotesTabUnsaved);
        }
    };
    const checkBoldFieldsInvoice = () => {
        if (formdata.invoiceNumber ||
            formdata.workOrderId ||
            formdata.debtorId ||
            formdata.invoiceDate ||
            formdata.bookMonth ||
            formdata.bookYear) {
            setIsInfoTabBold(true);
        }
        if (formdata.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        validateForm,
        formdata,
        errors,
        handleFieldChange,
        handleCalendarChange,
        setFormData,
        infoTabErrorBorderColor,
        isNotesTabUnsaved,
        isInfoTabUnsaved,
        isInfoTabBold,
        isNotesTabBold
    };
}
